import { useCallback } from 'react';
import { Date, DateService, useDateTimeLocalizationInfo } from '@mews/framework';

export const useLocalizeLongDate = () => {
    const localizationInfo = useDateTimeLocalizationInfo();

    return useCallback((date: Date) => DateService.toLongString(date, localizationInfo), [localizationInfo]);
};
